import { type ReactNode, useId, useState } from 'react';

/**
 * Подсказка при наведении (паттерн AnalysisMP).
 * Независимая реализация для mp_trend — без импорта из parsing-marketplaces.
 */
export function Tooltip({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  const id = useId();
  const [open, setOpen] = useState(false);

  return (
    <span
      className="relative inline-flex items-center"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      <span tabIndex={0} aria-describedby={open ? id : undefined} className="cursor-help">
        {children}
      </span>
      {open ? (
        <span
          id={id}
          role="tooltip"
          className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-max max-w-[260px] rounded-md border border-border-default/[0.18] bg-panel px-2.5 py-2 text-caption text-text-primary shadow-lg"
        >
          {label}
        </span>
      ) : null}
    </span>
  );
}
